import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const usePermissions = (moduleId, pageId) => {
  const module = useSelector((state) => state.Module.module);

  const permission = useMemo(() => {
    if (!module || !moduleId || !pageId) {
      return {};
    }

    const moduleItem = module.find(
      (m) => m.moduleId === moduleId
    );

    if (!moduleItem) {
      return {};
    }

    const pageItem = moduleItem.pages?.find((p) => p.pageId === pageId);

    if (moduleItem.modulePermission && pageItem && pageItem.permissions) {
      return {
        CanView: moduleItem.modulePermission.CanView && pageItem.permissions.CanView,
        CanAdd: moduleItem.modulePermission.CanAdd && pageItem.permissions.CanAdd,
        CanEdit: moduleItem.modulePermission.CanEdit && pageItem.permissions.CanEdit,
        CanDelete: moduleItem.modulePermission.CanDelete && pageItem.permissions.CanDelete,
        CanActive: moduleItem.modulePermission.CanActive && pageItem.permissions.CanActive,
      };
    }

    return {};
  }, [module, moduleId, pageId]);

  return permission;
};

export default usePermissions;